import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

export const headingTheme = defineStyleConfig({
    baseStyle: {
        h1: {
            fontSize: { base: '36px', md: '54px' },
            lineHeight: { base: '42px', md: '69px' },
            fontWeight: '600',
        },
        h2: {
            fontSize: { base: '26px', sm: '30px', md: '30px' },
            lineHeight: { base: '1.5', sm: '37px', md: '48px' },
            fontWeight: '600',
            textAlign: 'center',
        },
        h3: {
            fontSize: { base: '21px', sm: '21px' },
            fontWeight: '600',
            lineHeight: '31.5px',
            textAlign: 'center',
        },
        h4: {
            fontSize: { base: '16px', sm: '18px' },
            lineHeight: '27px',
        },
    },
    variants: {
        label: {
            color: 'dark.5',
            fontSize: { base: '24px', md: '26px' },
            fontWeight: '600',
            lineHeight: { base: '36px', md: '30px' },
            textAlign: 'center',
        },
    },
});
